import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";
export const ResourceFormikObj = {
    initialValues: {
        name: "",
    }
}

export const FormikObj = {
    initialValues: {
        id: "",
        name: "",
        organization: "",
        description: "",
        url: "",
        status: 'current',
        locations: [],
    },
    validationSchema: Yup.object({
        name: conditionalValidation(
            Yup.string().max(50, "Maximum length is 50 characters.").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Name",
                mandatory: true
            }),
        description: conditionalValidation(
            Yup.string().max(250, "Maximum length is 250 characters.").matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Description"
            }),
        url: conditionalValidation(
            Yup.string(),
            {
                validation,
                label:"URL",
                mandatory:true
            })
    }),
}

export const categoryOptions = [
    { value: "Lab Requisition", name: "Lab Requisition" },
    { value: "Diagnostic Requisition", name: "Diagnostic Requisition" },
    { value: "Referral", name: "Referral" },
    { value: "Prescription", name: "Prescription" }
];

export const truncateText = (text, limit) => {
    if (!text) return "-";
    if (text.length <= limit) return text;
  
    const lastSpaceIndex = text.lastIndexOf(" ", limit);
    return text.slice(0, lastSpaceIndex !== -1 ? lastSpaceIndex : limit) + "...";
};

export const noDataAvailText = "No Data Available";
export const resourceTableTitle = ["Name", "Description", "Location(s)", "Organization", "Date", "Status", "Action"]
export const resourceTableTitleSuperAdmin = ["Name", "Description", "Location(s)","Organiztion","Date", "Status", "Action"]